import { render } from "./Clients.vue?vue&type=template&id=09ce4fb0&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"

import "./Clients.vue?vue&type=style&index=0&id=09ce4fb0&lang=scss"
import "./Clients.vue?vue&type=style&index=1&id=09ce4fb0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ce4fb0"]])

export default __exports__